import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Plan } from '../_models';
import { environment } from '../../../environments/environment';

@Injectable()
export class PlanService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  // Ottiene tutti i piani
  getPlans(): Observable<Plan[]> {
    return this.http.get<Plan[]>(`${this.apiBaseUrl}api/private/v1/store/plans`);
  }

  // Ottiene un singolo piano tramite id
  getPlan(id: number): Observable<Plan> {
    return this.http.get<Plan>(`${this.apiBaseUrl}api/private/v1/store/plans/${id}`);
  }

  // Salva un piano (crea o aggiorna)
  savePlan(planItem: Plan): Observable<Plan> {
    const plan = { ...planItem };
    delete plan.lastUpdated;
    delete plan.dateCreated;

    if (plan.id) {
      return this.http.put<Plan>(`${this.apiBaseUrl}api/private/v1/store/plans/${plan.id}`, plan);
    } else {
      return this.http.post<Plan>(`${this.apiBaseUrl}api/private/v1/store/plans/`, plan);
    }
  }

  // Cancella un piano tramite id
  deletePlan(plan: Plan): Observable<Plan> {
    return this.http
      .delete<void>(`${this.apiBaseUrl}api/private/v1/store/plans/${plan.id}`)
      .pipe(map(() => ({ id: plan.id }) as Plan));
  }
}
